














































































import {Component, Prop} from "vue-property-decorator";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { EmailDetailEventsItem } from "@/store/email/statistic/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import EmailEventsDetailFilter from "@/components/Email/Statistic/EmailEventsDetailFilter.vue";
import EmailDetailFilter from "@/components/Email/Statistic/EmailDetailFilter.vue";

@Component({ components: {EmailDetailFilter, EmailEventsDetailFilter}, filters: {dateFilter} })
export default class EmailEventsDetail extends BaseItemsPage<EmailDetailEventsItem> {
  @Prop() readonly createDate!: string;
  @Getter("emailDetailEvents") responseItems: any;

  currentSort = "date";

  get messageId() {
    return this.$route.params.id
  }

  getData() {
    return this.responseItems;
  }

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'event_date', 'event_type', 'detail'
    ];
  }
}
